import { useTranslation } from '../i18n';
import React from 'react';
import { Space, Typography, Divider } from 'antd';

const { Title, Text } = Typography;

/**
 * 通用页面头部组件
 *
 * 提供统一的页面标题区域：标题 + 副标题 + 操作按钮组 + 可选 tags。
 * 已与全局布局集成，无需再包外层 padding/margin。
 *
 * Props:
 *  - title:      string | ReactNode    主标题
 *  - subtitle:   string | ReactNode    副标题（提示/说明）
 *  - extra:      ReactNode             右侧操作区（按钮组等）
 *  - tags:       ReactNode             标题旁的状态标签
 *  - onBack:     () => void            左侧返回按钮回调（可选）
 *  - icon:       ReactNode             标题左侧图标
 *  - dense:      bool                  紧凑模式（无下分隔线、较小间距）
 *  - children:   ReactNode             下方附加内容（如选项卡、Alert等）
 */
const PageHeader = ({
  title,
  subtitle,
  extra,
  tags,
  onBack,
  icon,
  dense = false,
  children,
  style,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`page-header ${className || ''}`} style={style}>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 16,
          flexWrap: 'wrap',
          marginBottom: dense ? 8 : 16,
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <Space size={12} align="center" wrap>
            {onBack && (
              <a
                onClick={onBack}
                style={{ fontSize: 14 }}
                role="button"
                tabIndex={0}
              >
                {t('← Back')}
              </a>
            )}
            {icon}
            <Title
              level={dense ? 5 : 4}
              style={{ margin: 0, lineHeight: 1.4 }}
            >
              {title}
            </Title>
            {tags}
          </Space>
          {subtitle && (
            <div style={{ marginTop: 4 }}>
              <Text type="secondary" style={{ fontSize: 13 }}>
                {subtitle}
              </Text>
            </div>
          )}
        </div>
        {extra && (
          <div style={{ flexShrink: 0 }}>
            <Space wrap size="small">{extra}</Space>
          </div>
        )}
      </div>
      {!dense && <Divider style={{ margin: '0 0 16px' }} />}
      {children}
    </div>
  );
};

export default PageHeader;
